export const medicalSpecialties = [
  {
      slug: 'allergy-and-immunology',
      name: 'Alergología E Inmunología Clínica'
  },
  {
      slug: 'pediatric-allergy-and-immunology',
      name: 'Alergología E Inmunología Pediátrica'
  },
  {
      slug: 'algology',
      name: 'Algología'
  },
  {
      slug: 'andrology',
      name: 'Andrología'
  },
  {
      slug: 'anesthesiology',
      name: 'Anestesiología'
  },
  {
      slug: 'angiología',
      name: 'Angiología'
  },
  {
      slug: 'angiología-vascular-surgery',
      name: 'Angiología Y Cirugía Vascular'
  },
  {
      slug: 'primary-care',
      name: 'Atención Primaria'
  },
  {
      slug: 'audiology',
      name: 'Audiología'
  },
  {
      slug: 'audiology-phoniatry',
      name: 'Audiología Y Foniatría'
  },
  {
      slug: 'cardiology',
      name: 'Cardiología'
  },
  {
      slug: 'cardiac-electrophysiology',
      name: 'Cardiología Electrofisiología'
  },
  {
      slug: 'cardiovascular-intervention',
      name: 'Cardiología Intervencionista'
  },
  {
      slug: 'pediatric-cardiology',
      name: 'Cardiología Pediátrica'
  },
  {
      slug: 'orthopaedic-surgery',
      name: 'Cirugía Artroscópica'
  },
  {
      slug: 'bariatric-surgery',
      name: 'Cirugía Bariátrica'
  },
  {
      slug: 'biliary-surgery',
      name: 'Cirugía Biliar'
  },
  {
      slug: 'cardiothoracic-vascular-surgery',
      name: 'Cirugía Cardio Torácica'
  },
  {
      slug: 'head-neck-surgery',
      name: 'Cirugía De Cabeza Y Cuello'
  },
  {
      slug: 'spine-surgery',
      name: 'Cirugía De Columna '
  },
  {
      slug: 'breast-surgery',
      name: 'Cirugía De Mama'
  },
  {
      slug: 'hand-surgery',
      name: 'Cirugía De Mano'
  },
  {
      slug: 'oral-and-dental-surgery',
      name: 'Cirugía Dental'
  },
  {
      slug: 'knee-surgery',
      name: 'Cirugía De Rodilla'
  },
  {
      slug: 'digestive-surgery',
      name: 'Cirugía Digestiva'
  },
  {
      slug: 'endoscopic-surgery',
      name: 'Cirugía Endoscópica'
  },
  {
      slug: 'general-surgery',
      name: 'Cirugía General'
  },
  {
      slug: 'laparoscopic-surgery',
      name: 'Cirugía Laparoscópica'
  },
  {
      slug: 'oral-and-maxillofacial-surgery',
      name: 'Cirugía Maxilofacial'
  },
  {
      slug: 'ophthalmologic-surgery',
      name: 'Cirugía oftalmológica'
  },
  {
      slug: 'surgical-oncology',
      name: 'Cirugía Oncológica'
  },
  {
      slug: 'pediatric-surgery',
      name: 'Cirugía Pediátrica'
  },
  {
      slug: 'plastic-surgery',
      name: 'Cirugía Plástica'
  },
  {
      slug: 'plastic-and-reconstructive-surgery',
      name: 'Cirugía Reconstructiva'
  },
  {
      slug: 'adult-reconstructive-orthopaedic-surgery',
      name: 'Cirugía Reconstructiva De Pelvis '
  },
  {
      slug: 'vascular-surgery',
      name: 'Cirugía Vascular'
  },
  {
      slug: 'orthopedic-surgeon-traumatologist',
      name: 'Cirujía Ortopédica y Traumatología'
  },
  {
      slug: 'colposcopy',
      name: 'Colposcopia'
  },
  {
      slug: 'dermatology',
      name: 'Dermatología'
  },
  {
      slug: 'dermapathology',
      name: 'Dermatología Oncológica'
  },
  {
      slug: 'pediatric-dermatology',
      name: 'Dermatología Pediátrica'
  },
  {
      slug: 'procedural-dermatology',
      name: 'Dermatología Quirúrgica'
  },
  {
      slug: 'endocrinology',
      name: 'Endocrinología'
  },
  {
      slug: 'pediatric-endocrinology',
      name: 'Endocrinología Pediátrica'
  },
  {
      slug: 'reproductive-endocrinology',
      name: 'Endocrinología Reproductiva E Infertilidad'
  },
  {
      slug: 'endodontics',
      name: 'Endodoncia'
  },
  {
      slug: 'gastroendoscopy',
      name: 'Endoscopia Gastrointestinal'
  },
  {
      slug: 'pediatric-endoscopy',
      name: 'Endoscopia Pediátrica'
  },
  {
      slug: 'endoscopy',
      name: 'Endoscopia  '
  },
  {
      slug: 'unknown-specialty',
      name: 'Especialidad Desconocida'
  },
  {
      slug: 'physical-therapy',
      name: 'Fisioterapia'
  },
  {
      slug: 'physical-medicine-and-rehabilitation',
      name: 'Fisioterapia Y Rehabilitación'
  },
  {
      slug: 'phoniatry',
      name: 'Foniatría'
  },
  {
      slug: 'gastroenterology',
      name: 'Gastroenterología'
  },
  {
      slug: 'pediatric-gastroenterology',
      name: 'Gastroenterología Pediátrica'
  },
  {
      slug: 'gastroenterology-surgery',
      name: 'Gastroenterología Quirúrgica'
  },
  {
      slug: 'gastroenterologist',
      name: 'Gastroenterólogo'
  },
  {
      slug: 'medical-genetics',
      name: 'Genética'
  },
  {
      slug: 'geriatric-medicine',
      name: 'Geriatría'
  },
  {
      slug: 'gynecologic-oncology',
      name: 'Ginecología Oncológica'
  },
  {
      slug: 'obstetrics-and-gynecology',
      name: 'Ginecología Y Obstetricia'
  },
  {
      slug: 'hematology-oncology',
      name: 'Hemato-Oncología'
  },
  {
      slug: 'pediatric-hematology-oncology',
      name: 'Hemato-Oncología Pediátrica'
  },
  {
      slug: 'hepatology',
      name: 'Hepatología'
  },
  {
      slug: 'homeopathy',
      name: 'Homeopatía'
  },
  {
      slug: 'infectious-disease',
      name: 'Infectología'
  },
  {
      slug: 'pediatric-infectious-diseases',
      name: 'Infectología Pediátrica'
  },
  {
      slug: 'critical-care-medicine',
      name: 'Intensivista'
  },
  {
      slug: 'pediatric-critical-care-medicine',
      name: 'Intensivista Pediátrica'
  },
  {
      slug: 'critical-intensive-care-medicine',
      name: 'Medicina Critica Y Terapia Intensiva'
  },
  {
      slug: 'critical-intensive-care-pediatric-medicine',
      name: 'Medicina Critica Y Terapia Intensiva Pediátrica'
  },
  {
      slug: 'pain-medicine',
      name: 'Medicina Del Dolor'
  },
  {
      slug: 'occupational-medicine',
      name: 'Medicina Del Trabajo'
  },
  {
      slug: 'sports-medicine',
      name: 'Medicina Deportiva'
  },
  {
      slug: 'family-medicine',
      name: 'Medicina Familiar'
  },
  {
      slug: 'general-practice',
      name: 'Medicina General'
  },
  {
      slug: 'homecare-medicine',
      name: 'Medicina General Consulta A Domicilio'
  },
  {
      slug: 'integrative-medicine',
      name: 'Medicina Integrada'
  },
  {
      slug: 'intensive-care-medicine',
      name: 'Medicina Intensivista'
  },
  {
      slug: 'internal-medicine',
      name: 'Medicina Interna'
  },
  {
      slug: 'perinatology',
      name: 'Medicina Materno Fetal'
  },
  {
      slug: 'nuclear-medicine-radiology',
      name: 'Medicina Nuclear'
  },
  {
      slug: 'palliative-medicine',
      name: 'Medicina Paliativa'
  },
  {
      slug: 'general-practitioner',
      name: 'Médico General'
  },
  {
      slug: 'menopause',
      name: 'Menopausia'
  },
  {
      slug: 'nephrology',
      name: 'Nefrología'
  },
  {
      slug: 'pediatric-nephrology',
      name: 'Nefrología Pediátrica'
  },
  {
      slug: 'neonatal-perinatal-medicine',
      name: 'Neonatología'
  },
  {
      slug: 'pulmonology',
      name: 'Neumología'
  },
  {
      slug: 'pediatric-pulmonology',
      name: 'Neumología Pediátrica'
  },
  {
      slug: 'neurological-surgery',
      name: 'Neurocirugía'
  },
  {
      slug: 'neurological-pediatric-surgery',
      name: 'Neurocirugía Pediátrica'
  },
  {
      slug: 'neurophysiology',
      name: 'Neurofisiología'
  },
  {
      slug: 'neurology',
      name: 'Neurología'
  },
  {
      slug: 'pediatric-neurology',
      name: 'Neurología Pediátrica'
  },
  {
      slug: 'neurology-neurological-surgery',
      name: 'Neurología Y Neurocirugía'
  },
  {
      slug: 'nutrition',
      name: 'Nutrición'
  },
  {
      slug: 'oculoplastics',
      name: 'Oculoplastica Y Vía Lagrimal'
  },
  {
      slug: 'general-dentist',
      name: 'Odontología'
  },
  {
      slug: 'pediatric-dentist',
      name: 'Odontología pediátrica'
  },
  {
      slug: 'pediatric-dentistry',
      name: 'Odontopediatria'
  },
  {
      slug: 'ophthalmology',
      name: 'Oftalmología'
  },
  {
      slug: 'pediatric-ophthalmology',
      name: 'Oftalmología Pediátrica'
  },
  {
      slug: 'oncology',
      name: 'Oncología'
  },
  {
      slug: 'pediatric-oncology',
      name: 'Oncología Pediátrica'
  },
  {
      slug: 'orthodontics',
      name: 'Ortodoncia'
  },
  {
      slug: 'orthodontics and dentofacil orthopedics',
      name: 'Ortodoncia (Ortopedia maxilofacial)'
  },
  {
      slug: 'orthopedics-traumatology',
      name: 'Ortopedia y Traumatologia'
  },
  {
      slug: 'otolaryngologist',
      name: 'Otolaryngologist'
  },
  {
      slug: 'otoneurology',
      name: 'Otoneurología'
  },
  {
      slug: 'otolaryngology',
      name: 'Otorrinolaringología'
  },
  {
      slug: 'pathology',
      name: 'Patología'
  },
  {
      slug: 'pediatrics',
      name: 'Pediatría'
  },
  {
      slug: 'periodontics',
      name: 'Periodoncia'
  },
  {
      slug: 'podiatry-podology',
      name: 'Podiatría'
  },
  {
      slug: 'proctology',
      name: 'Proctología'
  },
  {
      slug: 'prosthodontics',
      name: 'Prótesis dental (bucal)'
  },
  {
      slug: 'pshycology',
      name: 'Psicología'
  },
  {
      slug: 'psychiatry',
      name: 'Psiquiatría'
  },
  {
      slug: 'biochemestry',
      name: 'Química Biológica'
  },
  {
      slug: 'chiropractic',
      name: 'Quiropráctico'
  },
  {
      slug: 'diagnostic-radiology',
      name: 'Radiología'
  },
  {
      slug: 'radiology-vascular-and-interventional-radiology',
      name: 'Radiología Intervencionista'
  },
  {
      slug: 'radiation-oncology',
      name: 'Radioterapia'
  },
  {
      slug: 'rheumatology',
      name: 'Reumatología'
  },
  {
      slug: 'neurologic-endovascular-therapy',
      name: 'Terapia Endovascular Neurológica'
  },
  {
      slug: 'orthopaedic-trauma',
      name: 'Traumatología Y Ortopedia'
  },
  {
      slug: 'emergency-medicine',
      name: 'Urgencias Medicas'
  },
  {
      slug: 'urology',
      name: 'Urología'
  },
  {
      slug: 'urogynecology',
      name: 'Urología Ginecológica'
  },
  {
    slug: 'diabetology',
    name: 'Diabetología'
  }
];
